import { cn } from 'ui'

export const CanvasLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className={cn(
        'w-full flex flex-row',
        '[&>*:nth-child(2)]:!w-full [&>*:nth-child(2)]:md:!w-[calc(100%-36rem)]',
        '[&>div:first-child]:hidden [&>div:last-child]:hidden',
        '[&>div:last-child]:md:block [&>div:first-child]:md:block',
        '[&>div:first-child]:min-w-[300px] [&>div:first-child]:w-1/5 [&>div:last-child]:min-w-[300px] [&>div:last-child]:w-1/5'
      )}
    >
      {children}
    </div>
  )
}
